import { ContactsTableState } from './contacts-table.state';
import { Action, createReducer, on } from '@ngrx/store';
import {
    contactDeleteFailure,
    contactDeleteRequest, contactDeleteSuccess,
    contactSaveFailure,
    contactSaveRequest, contactSaveSuccess,
    contactsTableChangePage, contactsTableChangeQuery,
    contactsTableFailure, contactsTableMasterToggle,
    contactsTableRequest, contactsTableSetSelection,
    contactsTableSort,
    contactsTableSuccess, contactsTableToggle
} from './contacts-table.actions';

const initialState: ContactsTableState = {
    query: {
        sortColumn: 'id',
        sortDescending: false,
        filter: null,
        pageNumber: 1,
        itemsPerPage: 25
    },
    page: [],
    totalCount: null,
    filteredCount: null,
    busy: false,
    error: false,
    saving: false,
    deleting: false,
    selection: []
};

const reducer = createReducer(
    initialState,
    on(contactsTableRequest, (state) => ({
        ...state,
        busy: true,
        error: false
    })),
    on(contactsTableSuccess, (state, { totalCount, page }) => ({
        ...state,
        busy: false,
        page,
        totalCount,
        error: false,
        selection: state.selection.filter((id) => !!page.find((item) => item.id === id))
    })),
    on(contactsTableFailure, (state) => ({
        ...state,
        busy: false,
        error: true
    })),
    on(contactsTableChangePage, (state, { pageNumber, itemsPerPage }) => ({
        ...state,
        selection: [],
        query: { ...state.query, pageNumber, itemsPerPage }
    })),
    on(contactsTableChangeQuery, (state, { query }) => ({
        ...state,
        query
    })),
    on(contactsTableSort, (state, { id, descending }) => ({
        ...state,
        query: { ...state.query, sortColumn: id, sortDescending: descending }
    })),
    on(contactsTableSetSelection, (state, { selection }) => ({
        ...state,
        selection
    })),
    on(contactsTableToggle, (state, { id }) => ({
        ...state,
        selection: state.selection.indexOf(id) === -1 ? [ ...state.selection, id ] : state.selection.filter((sid) => sid !== id)
    })),
    on(contactsTableMasterToggle, (state) => ({
        ...state,
        selection: state.selection.length === 0 ? state.page.map(h => h.id) : []
    })),
    on(contactSaveRequest, (state) => ({
        ...state,
        saving: true
    })),
    on(contactSaveSuccess, (state, { contact }) => ({
        ...state,
        page: [ ...state.page.map((c) => c.id === contact.id ? contact : c) ],
        saving: false
    })),
    on(contactSaveFailure, (state) => ({
        ...state,
        saving: false
    })),
    on(contactDeleteRequest, (state) => ({
        ...state,
        deleting: true
    })),
    on(contactDeleteSuccess, (state) => ({
        ...state,
        deleting: false
    })),
    on(contactDeleteFailure, (state) => ({
        ...state,
        deleting: false
    }))
);

export function contactsTableReducer(state: ContactsTableState | undefined, action: Action): any {
    return reducer(state, action);
}
